module.exports = __webpack_public_path__ + "static/media/martas.b832dc0e.jpg";